import React from 'react';
import { MapPin } from 'lucide-react';

const AreasSection = () => {
  const areas = [
    {
      name: 'Liverpool',
      towns: 'City Centre, Anfield, Aigburth, Childwall, Dingle, Everton, Fazakerley, Garston, Kensington, Kirkdale, Old Swan, Speke, Toxteth, Tuebrook, Wavertree, West Derby, and Woolton.'
    },
    {
      name: 'Wirral',
      towns: 'Birkenhead, Wallasey, New Brighton, Bebington, Bromborough, Eastham, Heswall, Hoylake, West Kirby, Moreton, Leasowe, Greasby, Woodchurch, Caldy, Meols, and Port Sunlight.'
    },
    {
      name: 'Sefton',
      towns: 'Southport, Bootle, Crosby, Formby, Maghull, Litherland, Lydiate, Ainsdale, Blundellsands, and Melling.'
    },
    {
      name: 'Knowsley',
      towns: 'Huyton, Kirkby, Prescot, Halewood, Whiston, Cronton, and Stockbridge Village.'
    },
    {
      name: 'St Helens',
      towns: 'St Helens, Rainford, Haydock, Newton-le-Willows, Billinge, and Rainhill.'
    },
    {
      name: 'Cheshire Areas',
      towns: 'Chester and Ellesmere Port.'
    }
  ];

  return (
    <section id="areas" className="py-20 bg-gradient-to-b from-white to-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* SEO intro line */}
        <p className="text-center text-slate-500 text-base mb-6">
          We provide non-medical home support services across Liverpool, Wirral, Sefton, Knowsley, St Helens, Chester and Ellesmere Port.
        </p>

        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider">Coverage</span>
          <h2 className="text-4xl font-bold text-slate-900 mt-2 mb-4">Areas We Cover</h2>
          <p className="text-lg text-slate-600">
            AFT Senior Assisted Services provides reliable home support services across Merseyside and surrounding areas, including towns across Liverpool City Region and Cheshire.
          </p>
        </div>

        {/* Areas Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {areas.map((area, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-slate-200 hover:border-teal-300 hover:shadow-xl transition-all duration-300 p-8 group"
            >
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-br from-cyan-500 to-teal-600 rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <MapPin className="w-5 h-5 text-white" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 group-hover:text-teal-700 transition-colors">
                  {area.name}
                </h3>
              </div>
              <p className="text-slate-600 leading-relaxed text-sm">
                {area.towns}
              </p>
            </div>
          ))}
        </div>

        {/* Not listed notice */}
        <div className="bg-teal-50 border border-teal-200 rounded-2xl p-6 text-center mb-16">
          <p className="text-teal-800 text-base">
            If your location is not listed above, please{' '}
            <button
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
              className="font-semibold underline hover:text-teal-600 transition-colors"
            >
              contact us
            </button>
            {' '}as we may still be able to support you depending on availability.
          </p>
        </div>

        {/* Embedded Google Map */}
        <div className="rounded-2xl overflow-hidden shadow-xl border border-slate-200">
          <p className="text-center text-white font-semibold text-lg bg-gradient-to-r from-teal-600 to-cyan-600 py-4">
            Our Service Area Across Merseyside and Cheshire
          </p>
          <iframe
            title="AFT Senior Assisted Services Coverage Area"
            src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d154345.8!2d-2.9!3d53.4!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2suk!4v1"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>

      </div>
    </section>
  );
};

export default AreasSection;